import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

const footerLinks = [
  { label: 'Event', href: '/event' },
  { label: 'Membership', href: '/membership' },
  { label: 'Sponsorship', href: '/sponsorship' },
  { label: 'About', href: '/about' },
  { label: 'Gallery', href: '/gallery' },
  { label: 'Playlist', href: '/playlist' },
];

const legalLinks = [
  { label: 'Terms & Conditions', href: '/terms' },
  { label: 'Privacy Policy', href: '/privacy-policy' },
  { label: 'Cookie Policy', href: '/cookie-policy' },
];

export default function Footer() {
  return (
    <footer className="bg-dark-bg border-t border-accent/10">
      <div className="max-w-7xl mx-auto px-4 md:px-10 py-10 md:py-16">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 md:gap-10">
          {/* Left: Logo + Tagline */}
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-3">
              <AppLogo variant="light" size={150} />
            </div>
            <p className="text-white/40 text-sm max-w-xs leading-relaxed">
              Where every Pujo feels like home.
              <br />
              <span className="text-accent/60 font-medium">Prathaa 2026 · প্রথা</span>
            </p>
          </div>

          {/* Right: Links */}
          <nav className="flex flex-wrap gap-x-6 gap-y-3 md:gap-x-8">
            {footerLinks?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                className="text-white/60 text-sm font-medium hover:text-accent transition-colors duration-200"
              >
                {link?.label}
              </Link>
            ))}
            <a
              href="/assets/images/HCAF_PRATHA_2026_Sponsorship_Deck-71.pdf"
              download
              className="text-white/60 text-sm font-medium hover:text-accent transition-colors duration-200"
            >
              Download Brochure
            </a>
          </nav>
        </div>

        <div className="mt-8 md:mt-10 flex flex-wrap justify-center md:justify-start gap-x-5 gap-y-2">
          {legalLinks?.map((link) => (
            <Link
              key={link?.href}
              href={link?.href}
              className="text-white/40 text-xs font-medium hover:text-accent transition-colors duration-200"
            >
              {link?.label}
            </Link>
          ))}
        </div>

        <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex flex-col items-center md:items-start gap-1">
            <p className="text-white/30 text-xs tracking-wide text-center md:text-left">
              © 2026 HCAF — Hoyi Choyi Anondo Foundation. All Rights Reserved.
            </p>
            <a
              href="https://liqvd.asia/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/30 text-xs tracking-wide hover:text-accent transition-colors duration-200"
            >
              Powered by Liqvd Asia
            </a>
          </div>
          <div className="flex items-center gap-6">
            {/* Instagram */}
            <a
              href="https://instagram.com/HOYICHOYI"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="HCAF on Instagram"
              className="text-white/40 hover:text-accent transition-colors duration-200"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
              </svg>
            </a>
            {/* Facebook */}
            <a
              href="https://facebook.com/HOYICHOYI"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="HCAF on Facebook"
              className="text-white/40 hover:text-accent transition-colors duration-200"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </a>
            {/* Email */}
            <a
              href="mailto:hello@hoyichoyianondo.com"
              aria-label="Email HCAF"
              className="text-white/40 hover:text-accent transition-colors duration-200"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect width="20" height="16" x="2" y="4" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
              </svg>
            </a>
          </div>
          <p className="text-white/20 text-xs tracking-widest hidden md:block">
            PRATHAA 2026 · TRADITION — LIVING, NOT REMEMBERED
          </p>
        </div>
      </div>
    </footer>
  );
}
